import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import logo from "assets/img/logo.png"

export default function DefaultFooter() {
  return (
    <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>
      <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
        <div className='me-5 d-none d-lg-block'>
          <span style={{ marginRight: '10px', textAlign:"center" }}>Get connected with us on social networks :</span>
          <a href='https://www.youtube.com/@ykbutofficial' className='me-4 text-reset'>
            <MDBIcon style={{ marginRight: '10px' }} color='secondary' fab icon='youtube' />
          </a>
          <a href='https://www.instagram.com/ykbutofficial/' className='me-4 text-reset'>
            <MDBIcon style={{ marginRight: '10px' }} color='secondary' fab icon='instagram' />
          </a>
          <a href='https://www.facebook.com/ykbutofficial/' className='me-4 text-reset'>
            <MDBIcon style={{ marginRight: '10px' }} color='secondary' fab icon='facebook-f' />
          </a>
          {/* <a href='' className='me-4 text-reset'>
            <MDBIcon style={{ marginRight: '10px' }} color='secondary' fab icon='linkedin' />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon style={{ marginRight: '10px' }} color='secondary' fab icon='github' />
          </a> */}
        </div>
      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md='3' lg='4' xl='3' className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                Yayasan Karya Bakti UT
              </h6>
              <p>
                <img src={logo}></img>
              </p>
            </MDBCol>

            <MDBCol md='3' lg='3' xl='3' className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Unit Operasional</h6>
              <p>
                <a href='utschool' className='text-reset'>
                  UT SCHOOL
                </a>
              </p>
              <p>
                <a href='klinik-pratama' className='text-reset'>
                  KLINIK PRATAMA UT
                </a>
              </p>
              <p>
                <a href='dcare' className='text-reset'>
                   UT D'CARE
                </a>
              </p>
            </MDBCol>

            <MDBCol md='3' lg='2' xl='2' className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Tentang Yayasan</h6>
              <p>
                <a href='about' className='text-reset'>
                  Sekilas Yayasan
                </a>
              </p>
              <p>
                <a href='visi-misi' className='text-reset'>
                  Visi & Misi
                </a>
              </p>
              <p>
                <a href='budaya' className='text-reset'>
                  Budaya
                </a>
              </p>
              <p>
                <a href='struktur' className='text-reset'>
                  Struktur
                </a>
              </p>
              <p>
                <a href='jejak' className='text-reset'>
                  Milestone
                </a>
              </p>
            </MDBCol>

            <MDBCol md='4' lg='3' xl='3' className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Kontak</h6>
              <p>
                <MDBIcon style={{ marginRight: '10px' }} color='secondary' icon='home' className='me-2' />
                 Jl. Raya Bekasi No.KM. 22, Cakung Barat, Kecamatan Cakung, Kota Jakarta Timur, DKI Jakarta 13910
              </p>
              <p>
                <MDBIcon style={{ marginRight: '10px' }} color='secondary' icon='envelope' className='me-3' />
                official@ykbut.co.id
              </p>
              <p>
                <MDBIcon style={{ marginRight: '10px' }} color='secondary' icon='phone' className='me-3' /> 021 4600 464
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2024 Yayasan Karya Bakti United Tractors
        <a className='text-reset fw-bold' href='https://mdbootstrap.com/'>
          
        </a>
      </div>
    </MDBFooter>
  );
}
